/*@ngInject*/
angular.module('gw-um-header', [
    'umCore',
    'gw-um-j2js'
])
    .constant('headerConstant', {
        event: {
            CLOSE_USER_PROFILE_DROPDOWN: 'headerModule.CloseUserProfileDropdown'
        }
    })
    .run(function () {
    });


require('./externalStyles.less');

require('./header.i18n.json');
require('./header.less');
require('./header.tpl.html');
require('./headerComponent');
require('./headerController');
require('./headerUtil');

require('./help/help.i18n.json');
require('./help/help.less');
require('./help/help.tpl.html');
require('./help/helpComponent');
require('./help/helpController');

require('./help/aboutUmsModal/aboutUmsModal.i18n.json');
require('./help/aboutUmsModal/aboutUmsModal.less');
require('./help/aboutUmsModal/aboutUmsModal.tpl.html');
require('./help/aboutUmsModal/aboutUmsModalController');

require('./adminFunctionHeaderButtons/adminFunctionHeaderButtons.i18n.json');
require('./adminFunctionHeaderButtons/adminFunctionHeaderButtons.less');
require('./adminFunctionHeaderButtons/adminFunctionHeaderButtons.tpl.html');
require('./adminFunctionHeaderButtons/adminFunctionHeaderButtonsComponent');
require('./adminFunctionHeaderButtons/adminFunctionHeaderButtonsController');
require('./adminFunctionHeaderButtons/adminFunctionHeaderButtonsMediator');
require('./adminFunctionHeaderButtons/adminFunctionHeaderButtonsRepository');
require('./adminFunctionHeaderButtons/adminFunctionHeaderButtonsModel');

require('./userProfileButton/userProfileButton.i18n.json');
require('./userProfileButton/userProfileButton.less');
require('./userProfileButton/userProfileButton.tpl.html');
require('./userProfileButton/userProfileButtonComponent');
require('./userProfileButton/userProfileButtonController');

require('./userProfileButton/environment/environment.i18n.json');
require('./userProfileButton/environment/environment.less');
require('./userProfileButton/environment/environment.tpl.html');
require('./userProfileButton/environment/environmentComponent');
require('./userProfileButton/environment/environmentController');

require('./userProfileButton/userProfileDropdown/userProfileDropdown.i18n.json');
require('./userProfileButton/userProfileDropdown/userProfileDropdown.less');
require('./userProfileButton/userProfileDropdown/userProfileDropdown.tpl.html');
require('./userProfileButton/userProfileDropdown/userProfileDropdownComponent');
require('./userProfileButton/userProfileDropdown/userProfileDropdownController');

module.exports = 'gw-um-header';
